// Venster dat om een reden vraagt, en desgewenst een keuze. Voor handelingen
// die via de dispatcher lopen: die weigert zonder reden van minstens drie
// tekens, en die reden staat daarna in het auditlog en in de wachtrij.
//
//   const r = await vraagReden({ titel, uitleg, knop, keuzes: [{ waarde, label, uitleg }] });
//   r is null bij annuleren, anders { reden, keuze }.
import { esc } from '../lib/format.js';
import { t } from '../lib/i18n.js';

export function vraagReden({ titel, uitleg = '', knop = t('bond.voorstellen'), keuzes = [], gevaar = false, voorbeeld = t('bond.reden.voorbeeld') }) {
  return new Promise(klaar => {
    document.getElementById('redenModal')?.remove();
    const m = document.createElement('div');
    m.className = 'modal-overlay open';
    m.id = 'redenModal';
    m.innerHTML = `<div class="modal" style="max-width:520px">
      <div class="modal-header"><span class="modal-title">${esc(titel)}</span>
        <button type="button" class="btn-icon" data-reden="annuleer" title="${esc(t('alg.sluiten'))}"><i class="ti ti-x"></i></button></div>
      <div class="modal-body">
        ${uitleg ? `<p style="font-size:13px;color:var(--text-2);margin-bottom:12px">${esc(uitleg)}</p>` : ''}
        ${keuzes.map((k, i) => `<label class="eigendom-doc"><input type="radio" name="redenKeuze" value="${esc(k.waarde)}" ${i === 0 ? 'checked' : ''}>
          <span><strong>${esc(k.label)}</strong>${k.uitleg ? `<br><span class="start-sub">${esc(k.uitleg)}</span>` : ''}</span></label>`).join('')}
        <div class="form-group" style="margin-top:8px"><label class="form-label">${esc(t('bond.reden'))}</label>
          <input class="form-input" name="redenTekst" placeholder="${esc(voorbeeld)}"></div>
        <p style="font-size:12px;color:var(--text-3)">${esc(t('reden.uitleg'))}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-reden="annuleer">${esc(t('alg.annuleren'))}</button>
        <button type="button" class="btn ${gevaar ? 'btn-danger' : 'btn-primary'}" data-reden="ok">${esc(knop)}</button>
      </div></div>`;
    document.body.appendChild(m);
    const invoer = m.querySelector('[name="redenTekst"]');
    const sluit = uitkomst => { m.remove(); klaar(uitkomst); };
    m.addEventListener('submit', e => e.preventDefault());
    m.addEventListener('click', e => {
      if (e.target === m || e.target.closest('[data-reden="annuleer"]')) { sluit(null); return; }
      if (!e.target.closest('[data-reden="ok"]')) return;
      const reden = invoer.value.trim();
      if (reden.length < 3) { invoer.focus(); invoer.classList.add('fout'); return; }
      sluit({ reden, keuze: m.querySelector('[name="redenKeuze"]:checked')?.value || null });
    });
    invoer.focus();
  });
}
